export const idx_data_insert_sizes_od = [];

let order = 0;
let i = 0;
let d = 1;

idx_data_insert_sizes_od.push({
  size: '---',
  decimal: 0,
  order_idx: -1,
});

for (let j = 0; j <= 1; j++) {
  if (j > 0) {
    i = j;
  } else {
    i = '';
  }

  if (i == 1) {
    d = 0;

    idx_data_insert_sizes_od.push({
      size: i + '',
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_insert_sizes_od.push({
      size: (i + ' 1/64').trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_insert_sizes_od.push({
      size: (i + ' 1/32').trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;
  }

  d = 56;
  if (i == 0) {
    idx_data_insert_sizes_od.push({
      size: (i + ' 7/8').trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_insert_sizes_od.push({
      size: (i + ' 57/64').trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_insert_sizes_od.push({
      size: (i + ' 29/32').trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_insert_sizes_od.push({
      size: (i + ' 59/64').trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_insert_sizes_od.push({
      size: (i + ' 15/16').trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_insert_sizes_od.push({
      size: (i + ' 61/64').trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_insert_sizes_od.push({
      size: (i + ' 31/32').trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;

    idx_data_insert_sizes_od.push({
      size: (i + ' 63/64').trim(),
      decimal: i + d * (1 / 64),
      order_idx: order,
    });
    order++;
    d++;
  }
}
